"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var EyeSlashSvg_1 = require("./EyeSlashSvg");
var EyeSvg_1 = require("./EyeSvg");
var InputAdornment_1 = require("@material-ui/core/InputAdornment/InputAdornment");
var styles = {
    adornment: {
        color: '#0080cc',
        cursor: 'pointer'
    },
    iconContainer: {
        display: 'flex'
    }
};
var SeeHidePassword = (function (_super) {
    __extends(SeeHidePassword, _super);
    function SeeHidePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () { return _this.props.onClick(!_this.props.isPasswordVisible); };
        return _this;
    }
    SeeHidePassword.prototype.render = function () {
        return (React.createElement(InputAdornment_1.default, { style: styles.adornment, position: "start" },
            React.createElement("div", { "aria-label": this.getAriaLabel(), onClick: this.handleClick, style: styles.iconContainer }, this.getIcon())));
    };
    SeeHidePassword.prototype.getAriaLabel = function () {
        var isPasswordVisible = this.props.isPasswordVisible;
        return isPasswordVisible ? 'Hide the password' : 'See the password';
    };
    SeeHidePassword.prototype.getIcon = function () {
        var size = 20;
        return this.props.isPasswordVisible ? React.createElement(EyeSlashSvg_1.default, { size: size }) : React.createElement(EyeSvg_1.default, { size: size });
    };
    return SeeHidePassword;
}(React.Component));
exports.default = SeeHidePassword;
//# sourceMappingURL=SeeHidePassword.js.map